import t, { Fragment as n, createElement as r, Children as i, PureComponent as u } from "react";

function o(t, n) {
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}

function e() {
  return (e = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var i in r) {
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function c(t, n) {
  t.prototype = Object.create(n.prototype), t.prototype.constructor = t, t.__proto__ = n;
}

var f = function f() {},
    s = n ? function (t) {
  return t ? t.length > 1 ? r.apply(void 0, [n, null].concat(t)) : i.only(t) : null;
} : i.only,
    a = function (t) {
  function n() {
    for (var n, r = arguments.length, i = new Array(r), u = 0; u < r; u++) {
      i[u] = arguments[u];
    }

    return (n = t.call.apply(t, [this].concat(i)) || this).t = !1, n.i = null, n.u = f, n;
  }

  c(n, t);
  var r,
      i,
      u,
      e = n.prototype;
  return e.componentWillUnmount = function () {
    this.u();
  }, e.o = function (t) {
    var n = this;
    t !== this.i && (this.u(), this.i = null, t && (this.i = t, this.u = t.on("updated", function () {
      return n.forceUpdate();
    })));
  }, e.s = function () {
    var t = this.props,
        n = t.of || t.a || t.an || t.this || t.on,
        r = t.not ? "cannot" : "can";
    return t.ability[r](t.I || t.do, n, t.field);
  }, e.render = function () {
    return this.o(this.props.ability), this.t = this.s(), this.props.passThrough || this.t ? this.h() : null;
  }, e.h = function () {
    var t = this.props,
        n = t.children,
        r = t.ability,
        i = "function" == typeof n ? n(this.t, r) : n;
    return s(i);
  }, r = n, (i = [{
    key: "allowed",
    get: function get() {
      return this.t;
    }
  }]) && o(r.prototype, i), u && o(r, u), n;
}(u);

function h(t) {
  var n, r;
  return r = n = function (t) {
    function n() {
      return t.apply(this, arguments) || this;
    }

    return c(n, t), n;
  }(a), n.defaultProps = {
    ability: t
  }, r;
}

function l(t) {
  return function (n) {
    return r(t, null, function (t) {
      return r(a, e({
        ability: t
      }, n));
    });
  };
}

function v(n) {
  if ("production" !== process.env.NODE_ENV && "function" != typeof t.useContext) throw new Error("You must use React >= 16.8 in order to use useAbility()");
  var r = t.useContext(n),
      i = t.useState(),
      u = i[0],
      o = i[1];
  return t.useEffect(function () {
    return r.on("updated", function (t) {
      t.rules !== u && o(t.rules);
    });
  }, []), r;
}

export { a as Can, h as createCanBoundTo, l as createContextualCan, v as useAbility };